'use strict';

angular.module('shiftTraderApp')
  .controller('SplitShiftModalCtrl', function ($scope, params, Session, TimeService, toastr,
                                               WorkPeriods, $uibModalInstance, WorkPeriodStore,
                                               InternalAnalyticsService, ShiftTradeResponsesResource) {
    $scope.close = function() {
      $uibModalInstance.dismiss();
    };

    $scope.workPeriod = params.workPeriod;
    $scope.me = params.me;

    $scope.nowTime = TimeService.getNowInStoreTime();

    // get the latest workPeriod result just in case their screen has been open for a while
    WorkPeriods.getById(params.workPeriod.id)
      .then(function(currentWp) {
        $scope.workPeriod = currentWp;

        setTradeStatus($scope.workPeriod);
      }, function() {
        console.log('could not fetch current wp data');
      });

    var middleTime = moment($scope.workPeriod.start_time).add($scope.workPeriod.range_twix.length('minutes') / 2.0, 'minutes');

    if (!_.contains([0,15,30,45], middleTime.minutes())) {
      var numFifteens = Math.floor(middleTime.minutes() / 15);

      // middleTime minutes was weird, let's push it to the closest increment
      if ((middleTime.minutes() % 15) <= 7) {
        // round down to next smallest 15 minute increment

        middleTime.minutes(numFifteens * 15);
      } else {
        // round up to the next biggest 15 minute increment
        var newMin = numFifteens === 3 ? 0 : (numFifteens + 1) * 15;
        middleTime.minutes(newMin);
        if (newMin === 0) {
          middleTime.add(1, 'hours');
        }
      }
    }

    middleTime = middleTime.toDate();

    $scope.formData = {
      splitTime: middleTime
    };

    var startHour = $scope.workPeriod.start_time.hours();
    var startMinutes = $scope.workPeriod.start_time.minutes();

    var endHour = $scope.workPeriod.end_time.hours();
    var endMinutes = $scope.workPeriod.end_time.minutes();

    var processSplitTime = function() {
      var splitHour = $scope.formData.splitTime.getHours();
      var splitMinutes = $scope.formData.splitTime.getMinutes();

      // the case where you have a 10pm -> 4a shift and you want to split between midnight and 3:30am
      if (startHour > splitHour) {
        return moment($scope.workPeriod.end_time).hour(splitHour).minute(splitMinutes);
      } else {
        return moment($scope.workPeriod.start_time).hour(splitHour).minute(splitMinutes);
      }
    };

    var isTimeValid = function() {
      var lastValidHour = endHour;
      var splitHour = $scope.formData.splitTime.getHours();
      var splitMinutes = $scope.formData.splitTime.getMinutes();

      var validHours = [];

      var goOn = true;
      var hourCounter = startHour;

      while(goOn) {
        validHours.push(hourCounter);
        if (hourCounter === lastValidHour) {
          goOn = false;
        }

        if (hourCounter <= 22) {
          hourCounter++;
        } else {
          hourCounter = 0;
        }
      }

      var errorCode;

      if (!_.contains(validHours, splitHour)) {
        errorCode = -1;
      } else {

        // check if the length of shift will be too small...

        if (splitHour === startHour) {
          errorCode = splitMinutes > startMinutes ? 0 : -1;
        } else if (splitHour === endHour) {
          errorCode = splitMinutes < endMinutes ? 0 : -1;
        } else {
          errorCode = 0;
        }
      }

      // if we don't have an out-of-bounds error, then try to get the times and check for minimum shift length
      if (errorCode === 0) {
        var splitTime = processSplitTime();

        var rangeA = moment($scope.workPeriod.start_time).twix(moment(splitTime));
        var rangeB = moment(splitTime).twix(moment($scope.workPeriod.end_time));

        if (rangeA.length('minutes') < 30 || rangeB.length('minutes') < 30) {
          errorCode = -2;
        }
      }

      return errorCode;
    };


    $scope.state = {
      isTimeValid: true,
      existingShiftLength: parseFloat($scope.workPeriod.range_twix.length('minutes') / 60.0).toFixed(2),
      hasActiveTrade: null,
      endTimeAfterNow: $scope.workPeriod.end_time.isAfter($scope.nowTime)
    };

    var setTimeValidity = function() {
      var isTimeValidResult = isTimeValid();
      $scope.state.shiftIsTooShort = isTimeValidResult === -2;
      $scope.state.splitTimeIsOutOfBounds = isTimeValidResult === -1;
      $scope.state.isTimeValid = isTimeValidResult === 0;
    };

    var setTradeStatus = function(wp) {
      $scope.activeTrades = _.where(wp.related_trades, function(trade) {
        return trade.$isActive();
      });

      $scope.state.hasActiveTrade = ($scope.activeTrades.length > 0);
    };

    var initResultingShifts = function() {
      var splitTimeFmt = processSplitTime().format();

      $scope.shiftA = new WorkPeriods.initWithData(_.extend(_.clone($scope.workPeriod), {end_time: splitTimeFmt}));
      $scope.shiftB = new WorkPeriods.initWithData(_.extend(_.clone($scope.workPeriod), {start_time: splitTimeFmt}));

      $scope.state.shiftALength = parseFloat($scope.shiftA.range_twix.length('minutes') / 60.0).toFixed(2);
      $scope.state.shiftBLength = parseFloat($scope.shiftB.range_twix.length('minutes') / 60.0).toFixed(2);
    };

    setTimeValidity();
    initResultingShifts();

    setTradeStatus($scope.workPeriod);

    $scope.$watch('formData.splitTime', function(newVal, oldVal) {
      if (newVal !== oldVal) {
        setTimeValidity();

        if ($scope.state.isTimeValid) {
          // setup shiftB and shiftA
          initResultingShifts();
        }
      }
    });

    $scope.submitSplitShift = function() {
      var splitTimeFmt = processSplitTime().utc().format();

      $scope.workPeriod.$split(splitTimeFmt)
        .then(function(workPeriods) {
          console.log('splitWorkPeriods result', workPeriods);
          WorkPeriodStore.replaceById(workPeriods[0]);
          WorkPeriodStore.addWorkPeriods([workPeriods[1], workPeriods[2]])
            .then(function() {
              toastr.success('Shift was split successfully!', 'Success');
              $uibModalInstance.close(workPeriods);
            });

          InternalAnalyticsService.captureAnalytic('split_work_period', {
            _v: 1,
            _d: {
              originWorkPeriodId: $scope.workPeriod.id,
              outputWorkPeriodIds: [workPeriods[1].id, workPeriods[2].id],
              start_time: $scope.workPeriod.start_time.format(),
              end_time: $scope.workPeriod.end_time.format(),
              split_time: splitTimeFmt
            }
          });
        });
    };

    $scope.disapproveTrade = function (trade) {
      var response = new ShiftTradeResponsesResource();

      response.user_id = $scope.me.id;
      if (!trade.$isGiveaway()) {
        response.work_period_id = trade.trade_work_period.id;
      }
      response.shift_trade_id = trade.id;
      response.acceptance_code = 'DISAPPROVED';
      response.message = 'Trade disapproved so that shift could be split.';

      if (!trade.$isGiveaway() && _.where(trade.shift_trade_responses, {acceptance_code: 10}).length > 0) {
        response.shift_trade_response_id = _(_.where(trade.shift_trade_responses, {'acceptance_code':10})).pluck('id').__wrapped__[0];
      } else {
        response.shift_trade_response_id = null;
      }

      response.$save(function (response) {
        response.created_at = moment.utc(response.created_at).tz(Session.getTimezone());
        trade.shift_trade_responses.push(response);
        toastr.success('Trade disapproved.', 'Success');
        setTradeStatus($scope.workPeriod);
      }, function(response) {
        SAErrorHandler.processError(response);
      });
    };
  });
